import React, { useState, useEffect } from "react"

export const SpeechSettingsContext = React.createContext()

export const useSpeechSettingsContext = () => {
  const context = React.useContext(SpeechSettingsContext)
  if (context === undefined) {
    throw new Error(
      "useSpeechSettingsContext must be used within a SpeechSettingsProvider"
    )
  }
  return context
}

const SpeechSettingsProvider = ({ children }) => {
  const [speechSettings, setSpeechSettings] = useState({
    level: 1,
  })

  useEffect(() => {
    const getSpeechSettings = async () => {
      setSpeechSettings({
        level: 1,
      })
    }
    getSpeechSettings().catch(console.log)
  }, [])

  return (
    <SpeechSettingsContext.Provider
      value={{ speechSettings, setSpeechSettings }}
    >
      {children}
    </SpeechSettingsContext.Provider>
  )
}

export default SpeechSettingsProvider
